import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'components'
import { get } from 'services/api'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'

function ExportButton(props) {
  const { url, searchParams } = props

  const token = useSelector((state) => state.auth.access_token)

  const [loading, setLoading] = useState(false)

  const handleExport = () => {
    setLoading(true)
    get({
      url: url,
      token,
      params: searchParams,
    })
      .then(() => {
          toast.success('O relatório está sendo exportado. Um arquivo será enviado para o seu e-mail em instantes.')
      })
      .catch((error) => {
        console.error(error)
        toast.error('Erro ao exportar a tabela, por favor tente novamente')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Button fontSize={10} loadingSize={20} loading={loading} onClick={handleExport}>
      Exportar
  </Button>
  )
}

ExportButton.propTypes = {
  url: PropTypes.string.isRequired,
  searchParams: PropTypes.exact(
    {
      page: PropTypes.number,
      size: PropTypes.number,
      hide_empty_applications: PropTypes.bool,
      start_date: PropTypes.string,
      final_date: PropTypes.string,
      status: PropTypes.string,
      result: PropTypes.string,
      candidate_name: PropTypes.string,
      candidate_cpf: PropTypes.string,
      decision: PropTypes.string,
      waiting_clarification: PropTypes.bool,
    },
  ),
}

ExportButton.defaultProps = {
  searchParams: null,
}

export default ExportButton
